// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c6eaba64","545":"e94c2b36"}[chunkId] + ".chunk.js";
};